import script from "./InviteFriend01.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteFriend01.vue?vue&type=script&setup=true&lang=js"

import "./InviteFriend01.vue?vue&type=style&index=0&id=16b90ca5&lang=css"
import "./InviteFriend01.vue?vue&type=style&index=1&id=16b90ca5&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b90ca5"]])

export default __exports__